<template>
	<v-list-item
		class="notes-list__item"
		@click="selectNote"
	>
		<div style="flex-grow: 1;">
			<router-link 
				:to="{
					name: 'user-by-id',
					params: { id: this.resourceItem.follow_id}
				}"
				style="text-decoration: none;"
			>
				<div class="d-flex flex-nowrap align-center">
					<Avatar class="mr-3" size="50" :avatar="resourceItem.follow.user_logo" />
					<div style="width: 100%">
						<v-card-title class="notes-list__item-username pa-0">
							{{ resourceItem.follow.visible_username }}
						</v-card-title>
						<v-card-subtitle class="notes-list__item-date pa-0 ma-0">
							{{ dateCreated(resourceItem.note_updated) }}
						</v-card-subtitle>
					</div>
				</div>
			</router-link>
			<p
				v-html="resourceItem.follow_note"
				class='notes-list__item-text'							
			/>
		</div>
		<Icon 
			type="chevron_right"
			:size="18"
			color="#9B9B9B"
		/>
	</v-list-item>
</template>

<script>
import Avatar from '../Avatar'
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'

export default {
	name: 'NoteItem',
	components: {
		Avatar,
	},
	data () {
		return {
			fileColors: [
				{ color: '#50bee8', ext: ['jpg', 'jpeg', 'psd'] },
				{ color: '#6678aa', ext: ['bmp'] },
				{ color: '#a066aa', ext: ['png', 'gif'] },
				{ color: '#f15642', ext: ['pdf'] },
				{ color: '#50bee8', ext: ['doc', 'docx'] },
				{ color: '#638674', ext: ['rtf'] },
				{ color: '#f15642', ext: ['ppt'] },
				{ color: '#84bd5a', ext: ['xls', 'xlsx'] },
				{ color: '#f7b84e', ext: ['mp3', 'wav', 'flac'] },
				{ color: '#f7b84e', ext: ['avi', 'mp4', 'mpeg'] },
				{ color: '#576d7e', ext: ['txt'] },
				{ color: '#e59f2b', ext: ['zip', 'rar', '7z', 'gz', 'gzip', 'bzip'] },
				{ color: '#41a8e1', ext: ['url'] },
			]
		}
	},
	props: {
		resourceItem: {
			type: Object,
			default: () => {},
		}
	},
	computed: {
		...mapGetters('resources', ['resourcesList', 'isLoading', 'listMeta', 'breadCrumbs']),
	},
	methods: {
		...mapActions('resources', ['breadCrumbHandler']),
		...mapActions('profile', ['updateEditableNote']),

		folderClickHandler(resourceItem = {}) {
			const {resource_id: id, resources_name: name} = resourceItem

			this.breadCrumbHandler([{id, name}])
		},
		formateBreadCrumbs(resourceId) {
			const listIds = this.breadCrumbs.map(item => item.id)

			if (_.isEmpty(listIds)) {
				return {};
			}

			return {
				bread_crumbs: [...listIds, +resourceId].join(',')
			};
		},
		fileIconColor(file) {
			if (!file.filename) return '#8b8b8b'

			const extName = this.fileIconName(file)
			const colorDataObj = extName && this.fileColors.find((i) => i.ext.indexOf(extName) > -1)

			return colorDataObj ? colorDataObj.color : '#8b8b8b'
		},
		dateCreated(originalDate) {
			const date = new Date(originalDate * 1000);
			const options = {
				month: 'short',
				day: 'numeric',
				hour: 'numeric',
				minute: 'numeric',
				hour12: true
			}

			return new Intl.DateTimeFormat('en-US', options).format(date)
		},
		fileIconName(file) {
			if (file.metadata) {
				return (file.filename || '').split('.').pop().substring(0, 4)
			}

			return 'url'
		},
		selectNote() {
			this.updateEditableNote(this.resourceItem);
			this.$router.push({
				name: 'profile-note-by-id',
				params: { id: this.resourceItem.follow_id }
			});
		}
	},
	created() {
		//
	}
}
</script>

<style lang="scss">
.notes-list__item {
	width: 100%;
	display: flex;
	justify-content: space-between;
	flex-wrap: nowrap;
	padding: 16px !important;
	margin-bottom: 8px;
	border-radius: 10px;
	background: #fff;
	font-family: Montserrat, sans-serif;

	&-username {
		font-size: 18px;
		font-weight: 700;
		line-height: 21.94px;
		color: var(--accent-color);
		margin-bottom: 6px;
	}

	&-date {
		font-size: 15px;
		line-height: 20px;
		color: #4A4A4A;
	}

	&-text {
		font-size: 14px;
		line-height: 17.07px;
		color: #4A4A4A;
		margin: 16px 0 0 !important;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		word-break: break-word;
	}
}
</style>
